const openDownload = uri => {
  window.open(uri, '_blank')
}

export default openDownload
